import { render, staticRenderFns } from "./source.vue?vue&type=template&id=2dbb96bd&scoped=true&"
import script from "./source.vue?vue&type=script&lang=js&"
export * from "./source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb96bd",
  null
  
)

export default component.exports